<script setup lang="ts">
import { ref } from 'vue';

import { useEditor } from '@/composables/useEditor';

import ProductSelector from './ProductSelector.vue';
import SelectionPreview from './SelectionPreview.vue';

const { configurationManual: config } = useEditor();

const edit = ref(false);
</script>

<template>
  <div class="selection-manual">
    <SelectionPreview v-if="!edit" v-model:config="config" :allow-delete="config.products.length > 0" @configure="edit = true">
      <template #configure-subtitle>
        ({{ $t('editor.selection.from_any_provider') }})
      </template>
    </SelectionPreview>
    <ProductSelector v-else @save="edit = false" />
  </div>
</template>

<style lang="css" scoped>
</style>
